var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2375.48 1172.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d70e27;}.cls-3,.cls-4{fill:#dc0b27;}.cls-4{stroke:#dc0b27;stroke-miterlimit:10;stroke-width:7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.44,
    y: 14.55,
    width: 2246.82,
    height: 540
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    className: "cls-2",
    d: "M1327.47,213.37h-59.72v69.68h60.55a30.42,30.42,0,0,0,31.25-29.58,30,30,0,0,0-.15-4C1359.41,231.21,1349,213.37,1327.47,213.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    className: "cls-2",
    d: "M2061.57,210.88c-46.86,0-79.21,34.05-79.21,82.12,0,48.53,32.77,82.12,79.21,82.12,48.11,0,79.22-34,79.22-82.12C2140.76,243.23,2109.68,210.88,2061.57,210.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    className: "cls-2",
    d: "M279.4,216.27H236.28V368.9H279.4c52.27,0,70.51-39,70.51-78.8S329.59,216.27,279.4,216.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    className: "cls-3",
    d: "M.43,0V586.53H2375.48V0Zm279,438.16H155V147.84H279.35c102.46,0,151.81,63,151.81,143.09S383.51,438.16,279.35,438.16Zm285.35,0H483.06V147.84h81.69Zm177.1,8.3c-52.2.42-89.59-8.7-129.81-51.06l45.2-51.85a116.46,116.46,0,0,0,85,32.77c27,0,45.62-9.54,45.62-25.71,0-14.51-16.6-23.63-48.52-26.54-63.45-5.8-118.2-22-118.2-94.18,0-61.37,60.14-87.92,121.52-87.92A164.87,164.87,0,0,1,851.35,176.4L810.7,228.25a108.56,108.56,0,0,0-68-19.91c-19.92,0-39.4,6.22-39.4,21.56,0,19.92,19.48,22.82,48.11,25.73,57.64,6.21,117.78,29.5,117.78,96.22,0,66-62.18,94.19-127.32,94.6Zm399.81-231h-85V438.16H974.93V215.45H890.32v-67.6h251.33Zm312.71,222.71H1364L1296.35,344h-28.61v94.18h-82.11V147.84h141.84c74.24,0,112.81,47.66,112.81,99.94,0,35.67-12.48,66-61.39,87.51l75.48,97.88Zm126.93,0h-81.7V147.84h81.7Zm295.29-222.71h-85V438.16h-81.7V215.45h-84.6v-67.6H1876.6Zm185,229.76c-95,0-161.33-55.16-161.33-152.21,0-95.38,66.37-152.21,161.33-152.21,95.38,0,161.33,55.6,161.33,152.21,0,97.05-65.92,152.21-161.31,152.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    className: "cls-2",
    d: "M211.57,914.72v89.17H165.11V713.57c44.38,0,90-.41,134.37-.41,138.53,0,139,200.73,0,201.56Zm0-42.71h87.91c76.73,0,76.31-116.14,0-116.14H211.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    className: "cls-2",
    d: "M496.91,714v289.9H454.19V714Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    className: "cls-2",
    d: "M729.16,799.42h41.47v204.46H730l-2.08-33.18a80.83,80.83,0,0,1-70.5,38.58c-59.72.42-104.92-38.16-104.92-107.79,0-68.44,46.86-106.6,105.75-106.6a79,79,0,0,1,69.67,36.91Zm-134,102a64.46,64.46,0,0,0,60.76,68c1.87.1,3.74.13,5.6.07,88.34,0,88.34-135.62,0-135.62a64.33,64.33,0,0,0-66.41,62.19C595.09,897.85,595.1,899.65,595.2,901.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    className: "cls-2",
    d: "M988.8,799.42v19.91L886,962H989.64v41.88H820.41V986.47L926.18,838.41H827.46v-39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    className: "cls-2",
    d: "M1204.46,799.42h41.48v204.46h-40.65l-2.07-33.18a80.87,80.87,0,0,1-70.52,38.58c-59.71.42-104.92-38.16-104.92-107.79,0-68.44,46.86-106.6,105.77-106.6a79,79,0,0,1,69.67,36.91Zm-134,102a64.47,64.47,0,0,0,60.77,68c1.86.1,3.72.12,5.59.07,88.33,0,88.33-135.62,0-135.62a64.33,64.33,0,0,0-66.41,62.2C1070.39,897.85,1070.41,899.65,1070.5,901.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    className: "cls-2",
    d: "M1414.27,586.47H.5v9.08H1405.16v568.31H.5v9.08H1414.27Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 3.5,
    y1: 1165.86,
    x2: 3.5,
    y2: 588.47
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/logo-menu.3c9855a775c1e73ae3262b0184288fd6.svg";
export { ForwardRef as ReactComponent };